/**
 * 백엔드 LocalDateTime 필드(존 정보 없는 "2026-09-10T11:28:57" 형태)를 파싱하기 위한 공용
 * 유틸. 운영 서버 JVM이 UTC로 동작(KNOWN_ISSUES.md 2026-07-16 확인)해 LocalDateTime.now()가
 * UTC 벽시계 값을 그대로 기록하는데, Jackson이 이 값을 존 정보 없이 직렬화하다 보니
 * `new Date(value)`가 이 문자열을 "이미 브라우저 로컬 시간"으로 오인해 KST보다 9시간 이른
 * 시각으로 표시/계산되는 버그가 있었다(admin/batch 수동 실행 이력이 9시간 어긋나 보여
 * 사용자가 "방금 실행했는데 이력이 없다"고 오인한 것을 계기로 전수조사, 2026-09-10).
 * 존 정보가 이미 있는 값(Instant/OffsetDateTime 등, 또는 이미 'Z'가 붙은 값)은 그대로 둔다.
 */
export function parseServerTime(value: string | null | undefined): Date | null {
  if (!value) return null;
  const hasZoneInfo = /[zZ]|[+-]\d{2}:?\d{2}$/.test(value);
  return new Date(hasZoneInfo ? value : `${value}Z`);
}
